// Modules
import React, { useCallback, useEffect, useMemo, useState } from "react";
import cn from "classnames";

// Components
import FilterAccordionContent from "components/searchPage/FilterAccordion/FilterAccordionContent";

// Types
import { CurrentSelectedCategory } from "interfaces/searchPage/category";

// Redux
import { useAppSelector } from "redux/hooks";
import { availableFiltersSelector } from "redux/searchPage/filters/filtersSlice";

// Utils
import {isVisibleTag} from "utils/searchPage/categories";

interface FilterAccordionProps {
	activeFiltersByMacro: CurrentSelectedCategory;
}
const FilterAccordion = ({ activeFiltersByMacro }: FilterAccordionProps) => {
	const { macroCategory, selectedTags } = activeFiltersByMacro;
	const [showAllFilters, setShowAllFilters] = useState(false);
	const availableFilters = useAppSelector(availableFiltersSelector);

	const isAllowedTag = useCallback(
		(tag: { id: number }) => availableFilters.some((availableFilter) => availableFilter.id === tag.id),
		[availableFilters]
	);
	const filteredTags = useMemo(
		() => macroCategory.tags.filter(tag => isVisibleTag(tag) && isAllowedTag(tag)),
		[macroCategory.tags, isAllowedTag, isVisibleTag]
	);
	const hasActiveTag = useMemo(
		() => selectedTags.some(tag => macroCategory.tags.some(macroTag => macroTag.id === tag.id)),
		[selectedTags, macroCategory.tags]
	);

	useEffect(() => {
		if (hasActiveTag && filteredTags.length > 3) {
			setShowAllFilters(true);
		}
	}, [hasActiveTag]);

	if (filteredTags.length === 0) {
		return null;
	}

	const displayedTags = showAllFilters ? filteredTags : filteredTags.slice(0, 3);

	return (
		<div className="wk-accordion-item wk-active">
			<h5 className="wk-accordion-item__heading">
				{macroCategory.name}
			</h5>
			<div className="wk-accordion-item__content">
				<div className="wk-acc-text">
					{displayedTags.map((tag) => (
						<FilterAccordionContent key={tag.id} currentTag={tag} macroCategory={macroCategory} selectedTags={selectedTags} />
					))}
					{filteredTags.length > 3 && (
						<div className="wk-handle-filter-accordion" onClick={() => setShowAllFilters(!showAllFilters)}>
							<a>{showAllFilters ? "Visualizza meno" : "Visualizza di più"}</a>
							<span className={cn({
									"wk-icon-chevron-down": !showAllFilters,
									"wk-icon-chevron-up": showAllFilters,
								})}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default FilterAccordion;
